var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CTable',{attrs:{"columns":_vm.columns,"data":_vm.data,"total":_vm.total,"current":_vm.current,"show-page":true,"page-size":_vm.pageSize},on:{"change":_vm.change}})}
var staticRenderFns = []

export { render, staticRenderFns }